export const state = () => ({
	isOpen: false,

	settings: {}
});

export const mutations = {
	setOpen(state, params) {
		if (typeof params === "boolean") {
			params = {
				open: params
			}
		}

		state.isOpen = params.open;
		state.settings = params?.settings || {};
	}
};

/*
settings
 - title

*/